<template>
  <div class="p-filtersA">
    <div class="p-filtersA__left">
      <slot name="leftForm" />
    </div>
    <div class="p-filtersA__right">
      <slot name="rightForm" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompaniesAnalysisKeywordsHeader',
}
</script>